var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-as"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":`Login as ${_vm.user.first_name}`,"placement":"top"}},[_c('i',{staticClass:"el-icon-sort",on:{"click":_vm.loginAsUser}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }